import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-query";
import Cookies from "js-cookie";
import axios from "axios";
import styled from "@emotion/styled";
import { HorizontalGap, VerticalGap } from "../styled/gaps";
import { DAY_ORDER, NUMBER_DAY_MAP } from "../common/mappings";
import { Switch } from "@mui/material";
import { DaysSlots } from "./DaysSlots";
import { TimingsForm } from "./TimingsForm";
import { useGetTimingsQuery } from "src/api/timingsApiSlice";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const DaySelector = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const dataIsNotNull = (data) => {
  return data && data.data && data.data.data && data.data.data.workingHours;
};

const prepareOpenAndClosedLists = (data) => {
  const rData = {
    open: [],
    closed: [],
  };

  if (!dataIsNotNull(data)) {
    return rData;
  }

  let workingHours = dataIsNotNull(data);

  DAY_ORDER.forEach((number) => {
    if (workingHours[number].length > 0) {
      rData.open.push({ day: number, slots: workingHours[number] });
    } else {
      rData.closed.push({ day: number, slots: workingHours[number] });
    }
  });

  console.log(JSON.stringify(rData));
  return rData;
};

const getTimingsData = (data) => {
  let workingHours = dataIsNotNull(data);
  console.log("edit", JSON.stringify(workingHours));
  return workingHours;
};

const TimingsFormWrapper = (props) => {
  const { data, isLoading, isSuccess, isError, error } = useGetTimingsQuery();

  useEffect(() => {
    console.log("From Form", data);
  }, [data]);

  if (isLoading) {
    return "Loading...";
  }
  if (isError) {
    return `${error.message}`;
  }
  if (isSuccess) {
    return <Container>{data ? <TimingsForm data={data} /> : null}</Container>;
  }
};

export { TimingsFormWrapper };
